import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaintbrush20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPaintbrush20"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Paintbrush20)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m15.206 7.027 1.414-1.414a1.5 1.5 0 1 0-2.12-2.121l-1.414 1.414zm-1.768-4.596-1.414 1.414-.933-.933a2.3 2.3 0 0 0-3.253 0l-1.91 1.91a1.5 1.5 0 0 0-.406 1.37 1.5 1.5 0 0 0-.186.158L1.801 9.885a1.5 1.5 0 0 0 0 2.122l6.304 6.304a1.5 1.5 0 0 0 2.121 0l3.536-3.536q.087-.087.158-.185c.48.1.999-.035 1.37-.407l1.91-1.91a2.3 2.3 0 0 0 0-3.252l-.933-.933 1.414-1.414a3 3 0 1 0-4.243-4.243M10.03 3.973l.934.933 1.06 1.06 2.121 2.122 1.061 1.06.933.934a.8.8 0 0 1 0 1.131l-1.909 1.91-7.24-7.241 1.909-1.91a.8.8 0 0 1 1.131 0m-7.168 6.973L6.397 7.41l6.304 6.304-3.535 3.535-.677-.677 2.057-2.058a.75.75 0 0 0-1.06-1.06l-2.058 2.057-.884-.883.782-.782a.75.75 0 0 0-1.06-1.061l-.783.782-.884-.884 1.59-1.59a.75.75 0 0 0-1.06-1.06l-1.59 1.59z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Paintbrush20">
                        <path fill="#fff" d="M0 0h20v20H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconPaintbrush20);
